import { render, staticRenderFns } from "./catCode.vue?vue&type=template&id=4a40640d"
import script from "./catCode.vue?vue&type=script&lang=js"
export * from "./catCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports